import { CentricNode } from '@modules/common/models/interfaces/CentricNode'
import { strings } from '@stores'
import filter from 'lodash/filter'
import isEqual from 'lodash/isEqual'
import map from 'lodash/map'
import memoize from 'memoize-one'

interface IClient {
  Id: string
  Name: string
  c8__Parent__: CentricNode
}

interface IClientTableData {
  id: string
  name: string
}

class ClientSearchManagementService {
  /**
   * Method for converting client data received in response into the format that can be passed to standard tree table
   * @params {ClientDataWithCustomerGroupEnums} - Object with list of clients and enum values
   * @returns {Array<IClientTableData>}
   */
  processClientData = memoize(({ clients }): Array<IClientTableData> => {
    return map(clients, (client: IClient) => ({
      id: client.Id,
      name: client.Name,
      zone: client?.c8__Parent__?.Name ?? ''
    }))
  }, isEqual)

  /**
   * Method for converting client data received in response into the format that can be passed to standard tree table
   * @params {ClientData} - Object with list of clients
   * @returns {Array<IClientTableData>}
   */
  processAndFilterClientData = memoize((client: IClient, selectedZone: string = '') => {
    let processedClientData = this.processClientData(client)
    /**
     * If selectedZone is present filter clients
     */
    if (selectedZone && selectedZone !== strings.worldWide) {
      let filteredResult = filter(
        processedClientData,
        (client: any) => client.zone === selectedZone
      )
      return filteredResult
    }
    return processedClientData
  })
}

export const clientSearchManagementService = new ClientSearchManagementService()
